import { render, staticRenderFns } from "./PainelAgead.vue?vue&type=template&id=84bf5734"
import script from "./PainelAgead.vue?vue&type=script&lang=js"
export * from "./PainelAgead.vue?vue&type=script&lang=js"
import style0 from "./PainelAgead.vue?vue&type=style&index=0&id=84bf5734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports